export * from "./simular-icon.component";
